import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';
import { EnrollmentLog } from '../../../../../AdminLogs/models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserEnrollments: builder.query<
      EnrollmentLog[],
      { accountId: string; personId: number }
    >({
      query: ({ accountId, personId }) =>
        `/v4/accounts/${accountId}/orders/${personId}`,
    }),
  }),
});

export const { useGetUserEnrollmentsQuery } = apiSlice;
